export const formatDate = (date) => {
  if (!date) return '';

  if (typeof date === 'string') {
    // If input is already in yyyy-mm-dd format, return it directly
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
  }

  // Only use Date() if it's already a Date object
  const d = date instanceof Date ? date : new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


export const getTodayDate = () => formatDate(new Date());

export const getMinDateForAge18 = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 18);
  return formatDate(today);
};


export const formatPhoneNumber = (input) => {
  if (!input) return '';
  const cleaned = input.toString().replace(/\D/g, '');
  if (cleaned.length !== 10) return input;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};

export const formatSSN = (input) => {
  if (!input) return '';
  const cleaned = input.toString().replace(/\D/g, '');
  if (cleaned.length !== 9) return input;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
};
